import { FormikErrors } from "formik";
import { NotificationTriggerError } from "./NotificationSettings";
export type NotificationSettingsValues = {
  notificationTriggers: import("./types").ServiceProductNotificationTriggers[];
};

export function validateNotificationTriggers(
  values: NotificationSettingsValues
) {
  const errors = values.notificationTriggers.map(trigger => {
    const triggerErrors: NotificationTriggerError = {};
    if (!trigger.email) triggerErrors.email = "Required";
    if (!trigger.thresholds || trigger.thresholds.length === 0)
      triggerErrors.thresholds = ["At least one threshold is required"];
    if (trigger.email === "invalid") triggerErrors.email = "Invalid email";
    if (typeof triggerErrors.thresholds === "string") {
      triggerErrors.thresholds = [triggerErrors.thresholds];
    }
    return triggerErrors;
  });
  return { notificationTriggers: errors };
}

export function normalizeErrors(
  errors: FormikErrors<NotificationSettingsValues>
): NotificationTriggerError[] {
  const triggers = errors.notificationTriggers;
  if (!Array.isArray(triggers) || triggers.length === 0) return [];
  return triggers.map(e => {
    if (typeof e === "string") {
      return { email: e, thresholds: [e] };
    }
    return {
      ...e,
      thresholds: Array.isArray(e?.thresholds)
        ? e.thresholds
        : e?.thresholds
        ? [e.thresholds]
        : []
    };
  });
}
